import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation, useNavigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./lib/auth";
import Navbar from "./components/Navbar";
import ImpersonationBanner from "./components/ImpersonationBanner";
import Landing from "./pages/Landing";
import AuthCallback from "./pages/AuthCallback";
import Dashboard from "./pages/Dashboard";
import LessonPlayer from "./pages/LessonPlayer";
import LessonPlayerInteractive from "./pages/LessonPlayerInteractive";
import Pricing from "./pages/Pricing";
import PaymentReturn from "./pages/PaymentReturn";
import Logbook from "./pages/Logbook";
import SchoolAdmin from "./pages/SchoolAdmin";
import StudentReport from "./pages/StudentReport";
import InstructorConsole from "./pages/InstructorConsole";
import StudentDebriefs from "./pages/StudentDebriefs";
import "@/App.css";

function AppRouter() {
  const location = useLocation();
  // Detect Emergent OAuth callback BEFORE normal routing
  if (location.hash?.includes("session_id=")) return <AuthCallback />;

  // Immersive routes — hide the navbar so the lesson feels like a sim pod
  const isImmersive = location.pathname.startsWith("/lesson/") || location.pathname.startsWith("/lesson-interactive/");

  return (
    <>
      {!isImmersive && <ImpersonationBanner />}
      {!isImmersive && <Navbar />}
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/lesson/:lessonId" element={<LessonPlayer />} />
        <Route path="/lesson-interactive/:lessonId" element={<LessonPlayerInteractive />} />
        <Route path="/report/:lessonId" element={<StudentReport />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/billing/return" element={<PaymentReturn />} />
        <Route path="/logbook" element={<Logbook />} />
        <Route path="/admin" element={<SchoolAdmin />} />
        <Route path="/instructor" element={<InstructorConsole />} />
        <Route path="/debriefs" element={<StudentDebriefs />} />
      </Routes>
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster theme="light" position="top-right" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
